import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri';
import LastFetched from './LastFetched';




const HeaderPagination = ({
  date,
  loading,
  showReset,
  setReset,
  pagination,
  setPage,
  page,
}) => {
  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  return (
    <div className="flex justify-between items-center text-gray-800 text-sm font-medium">
      <span>{pagination?.totalDocuments || 0} Logs</span>
      <div className="flex items-center gap-2">
        {(pagination?.totalPages || 1) > 1 && (
          <div className="flex items-center gap-[4px]">
            <span>
              {pagination?.rows || 0}-{pagination?.page || 0} of{' '}
              {pagination?.totalPages || 0}
            </span>
            <div className="hover:bg-gray-200 hover:rounded-[5px] p-1 hover:transition-all hover:duration-100 text-black">
              <RiArrowLeftSLine
                size={16}
                className={`text-gray-900 ${pagination?.page === 1
                    ? 'opacity-50 cursor-not-allowed'
                    : 'cursor-pointer'
                  }`}
                onClick={() => {
                  if ((pagination?.page || 0) > 1) {
                    handleChangePage(page - 1);
                  }
                }}
              />
            </div>
            <div className="hover:bg-gray-200 hover:rounded-[5px] p-1 hover:transition-all hover:duration-100 text-black">
              <RiArrowRightSLine
                size={16}
                className={`text-gray-900  ${pagination?.totalPages === pagination?.page
                    ? 'opacity-50 cursor-not-allowed'
                    : 'cursor-pointer'
                  }`}
                onClick={() => {
                  if (pagination?.totalPages !== pagination?.page) {
                    handleChangePage(page + 1);
                  }
                }}
              />
            </div>
          </div>
        )}
        {!!showReset && (
          <LastFetched setReset={setReset} loading={loading} date={date} />
        )}
      </div>
    </div>
  );
};

export default HeaderPagination;
